"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var Styled = _interopRequireWildcard(require("./CtaButton.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var CtaButton = function CtaButton(props) {
  var p = props.p,
      pt = props.pt,
      pb = props.pb,
      pl = props.pl,
      pr = props.pr,
      symbol = props.symbol,
      iconBackground = props.iconBackground;
  var buttonProps = (0, _tslib.__assign)({}, props);
  var pad = {
    p: p,
    pt: pt,
    pb: pb,
    pl: pl,
    pr: pr
  };
  return React.createElement(Styled.CtaButton, (0, _tslib.__assign)({}, buttonProps), React.createElement(Styled.CtaButtonIcon, (0, _tslib.__assign)({}, pad, {
    bg: iconBackground
  }), symbol), React.createElement(Styled.CtaButtonText, (0, _tslib.__assign)({}, pad), props.children));
};

CtaButton.displayName = 'CtaButton';
CtaButton.defaultProps = {
  as: 'button',
  fontSize: [4, 5],
  color: 'black',
  bg: 'white',
  borderRadius: '12px',
  iconBackground: 'black'
};
var _default = CtaButton;
exports.default = _default;